export const primaryColor = '#9db9fc';
export const primaryColorLight = '#1b2b4d';
export const primaryColorDark = '#0f1a28';
export const primaryColorFocused = '#252e52';
export const backgroundColor = '#222731';
export const background = `linear-gradient(45deg, #1b2640 30%, #1b2b4d 90%)`;
export const backgroundFocused = `linear-gradient(45deg, #6b84c0 30%, #9db9fc 90%)`;
export const postBackgroundColor = '#1c263e';
export const textColor = '#c6d0e8';
export const secondaryColor = '#1b2b4d';
export const thumbColor = '#273f72';
//# sourceMappingURL=colors.js.map